export const Wolf404Gradient = () => {
  return (
    <svg
      width="282"
      height="100"
      viewBox="0 0 282 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M141.013 0C113.216 0 90.6802 22.5356 90.6802 50.3329C90.6802 60.1384 93.4873 69.291 98.3444 77.0336C99.2061 76.3416 100.146 75.8454 101.138 75.4537C103.123 74.6834 105.277 74.3439 107.301 73.7825C109.495 73.1688 111.545 71.589 112.328 69.7872C109.586 69.3955 106.779 69.3302 104.089 67.9723C104.507 67.6459 104.833 67.3978 105.134 67.1236C108.476 64.1859 111.819 61.2613 115.122 58.2713C115.697 57.7491 116.127 56.9787 116.415 56.2345C117.942 52.2653 119.378 48.27 120.919 44.3139C121.193 43.6219 121.676 42.9038 122.277 42.4729C124.601 40.8278 127.003 39.3132 129.354 37.7073C129.785 37.42 130.215 36.9631 130.385 36.493C132.174 31.4532 134.785 26.8834 137.984 22.6139C139.734 20.2899 141.326 17.8483 142.932 15.4198C143.442 14.6625 143.99 14.6625 144.682 14.9889C148.038 16.6079 150.727 21.7783 150.114 25.4472C149.8 27.2882 149.461 29.1161 149.147 30.957C149.095 31.2573 149.095 31.5707 149.043 32.1321C151.524 31.1007 152.882 29.0769 154.696 27.4448C156.12 30.1084 156.994 32.6805 155.689 35.6835C155.088 37.0806 154.762 38.7257 154.788 40.2402C154.866 44.1964 155.206 48.1394 155.454 52.0825C155.454 52.1739 155.441 52.2653 155.428 52.5134C154.618 51.8083 153.887 51.1686 153.156 50.5418C153.077 50.5941 152.986 50.6332 152.986 50.6724C152.855 56.117 153.09 61.5354 154.266 66.8756C154.618 68.4815 155.323 70.0091 155.885 71.6412C155.166 71.6412 154.292 71.6412 153.299 71.6412C153.378 80.1018 152.908 88.3536 150.401 96.5139C150.048 97.6759 149.643 98.838 149.2 100C173.093 96.083 191.32 75.3362 191.32 50.3329C191.333 22.5356 168.797 0 141.013 0Z"
        fill="url(#paint0_linear_9995_69928)"
      />
      <path
        d="M0.315918 66.9278V65.7266L33.1139 0H33.6493L56.0543 1.99765L56.9813 3.9953L23.3868 62.7889V63.3242H48.3117L53.2471 37.6028H69.3719V63.3242H84.165V80.5197H69.3719V99.9869H47.1105V80.5197H2.84889L0.315918 66.9278Z"
        fill="url(#paint1_linear_9995_69928)"
      />
      <path
        d="M197.848 66.9278V65.7266L230.646 0H231.182L253.587 1.99765L254.514 3.9953L220.906 62.8019V63.3372H245.831L250.766 37.6028H266.891V63.3372H281.684V80.5327H266.891V100H244.63V80.5327H200.368L197.848 66.9278Z"
        fill="url(#paint2_linear_9995_69928)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9995_69928"
          x1="200.5"
          y1="102"
          x2="85.5"
          y2="-13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--aw-palette-promo-main)" />
          <stop offset="1" stopColor="var(--aw-palette-promo-dark)" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9995_69928"
          x1="200.5"
          y1="102"
          x2="85.5"
          y2="-13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--aw-palette-promo-main)" />
          <stop offset="1" stopColor="var(--aw-palette-promo-dark)" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9995_69928"
          x1="200.5"
          y1="102"
          x2="85.5"
          y2="-13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--aw-palette-promo-main)" />
          <stop offset="1" stopColor="var(--aw-palette-promo-dark)" />
        </linearGradient>
      </defs>
    </svg>
  );
};
